import axios from 'axios';

// internal
import { DomainResponse, DomainType } from '../types/domain';

// service
export const surveyClientService = process.env['SURVEY_ENDPOINT_API_CLIENT'] || process.env['NX_PUBLIC_SERVICE'] || '';
export const surveyServerService = process.env['SURVEY_ENDPOINT_API_SERVER'] || '';
export const callCenterService = process.env['SURVEY_ENDPOINT_API_CLIENT'] || '';

export const getDomain = async (domain?: DomainType): Promise<Record<DomainType, string>> => {
    try {
        const instance = axios.create({
            baseURL: surveyClientService,
            headers: { 'Content-Type': 'application/json' },
        });

        const { data } = await instance<DomainResponse>({
            method: 'GET',
            url: '/auth/domain'
        })

        if (!data.data) {
            return {} as Record<DomainType, string>
        };

        if (!domain) {
            return data.data as Record<DomainType, string>
        }

        return { [domain]: data.data[domain] || '' } as Record<DomainType, string>
    } catch (error) {
        return Promise.reject('get domain error');
    }
}